module.exports = __webpack_public_path__ + "c_static/img/京东-核对店铺.b842bc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/京东-核对店铺.jpg
// module id = 93GD
// module chunks = 33